import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, HeartHandshake } from "lucide-react";
import { logAttribution } from "@/lib/tracking";

const SHOWN_KEY = "ehc_exit_shown";

export default function ExitIntentModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(SHOWN_KEY)) return;
    // desktop only
    if (window.innerWidth < 1024) return;

    const onMouseLeave = (e) => {
      if (e.clientY <= 0 && !sessionStorage.getItem(SHOWN_KEY)) {
        sessionStorage.setItem(SHOWN_KEY, "1");
        setOpen(true);
        logAttribution("exit_modal_shown");
      }
    };
    document.addEventListener("mouseleave", onMouseLeave);
    return () => document.removeEventListener("mouseleave", onMouseLeave);
  }, []);

  if (!open) return null;

  return (
    <div
      data-testid="exit-modal"
      className="fixed inset-0 z-[70] flex items-center justify-center p-6 bg-navy-900/70 backdrop-blur-sm animate-fade-in"
      onClick={() => setOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative max-w-md w-full bg-white rounded-3xl p-10 shadow-2xl animate-fade-up"
      >
        <button
          onClick={() => setOpen(false)}
          data-testid="exit-modal-close"
          className="absolute top-4 right-4 text-navy-400 hover:text-navy-900"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold-100 text-gold-500">
          <HeartHandshake className="h-6 w-6" strokeWidth={1.5} />
        </span>
        <h3 className="mt-5 font-serif text-3xl text-navy-900 leading-tight">
          Before you go — a quiet moment for your family.
        </h3>
        <p className="mt-4 text-navy-600 leading-relaxed">
          A free, no-obligation 20-minute consultation often changes the entire
          picture. Our care coordinator will listen first, share honestly, and
          only recommend what fits.
        </p>
        <Link
          to="/contact"
          onClick={() => {
            logAttribution("exit_modal_cta");
            setOpen(false);
          }}
          data-testid="exit-modal-cta"
          className="btn-primary w-full mt-7 justify-center"
        >
          Schedule my free consultation
        </Link>
        <button
          onClick={() => setOpen(false)}
          data-testid="exit-modal-dismiss"
          className="w-full mt-3 text-sm text-navy-500 hover:text-navy-900"
        >
          No thanks, I'll keep browsing
        </button>
      </div>
    </div>
  );
}
